
import React, { useState } from 'react';
import './signup.css';
import logo from './PKC_Map_Marker.png';

const items = [
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58595501-2025', title: 'All Saints', id: 1 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58595538-2025', title: 'All Souls', id: 2 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603179-2025', title: 'Annunciation Catholic Church', id: 3 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603235-2025', title: 'Ascension', id: 4 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603417-2025', title: 'Assumption of the blessed Virgin Mary - Welby', id: 5 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603458-2025', title: 'Blessed Sacrament', id: 6 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603486-2025', title: 'Cathedral Basilica of the Immaculate Conception ', id: 7 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603515-2025', title: 'Church of the Risen Christ', id: 8 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603553-2025', title: 'Good Shepherd Catholic Parish', id: 9 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58603787-2025', title: 'Guardian Angels-Mead', id: 10 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615715-2025', title: 'guardian angels', id: 11 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615715-2025', title: 'Guardian Angels Catholic Church', id: 12 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58604035-2025', title: 'Holy ghost', id: 13 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58604167-2025', title: 'Holy Name Catholic Parish', id: 14 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58604172-2025', title: 'Immaculate Heart of Mary', id: 15 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58676951-2025', title: 'Ignatius of Loyola', id: 16 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58562258-2025', title: 'Light of the World', id: 17 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58604364-2025', title: 'Most Precious Blood Catholic Church', id: 18 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58604353-2025', title: 'Nativity', id: 19 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58604353-2025', title: 'Nativity of Our Lord', id: 20 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58606968-2025', title: 'Notre Dame', id: 21 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58607017-2025', title: 'Our Lady of Fatima Lakewood', id: 22 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610192-2025', title: 'Our Lady of Loreto Catholic Church', id: 23 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610231-2025', title: 'Our Lady of Lourdes', id: 24 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610308-2025', title: 'Our Lady of the Pines', id: 25 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610352-2025', title: 'Our Lady of the Valley', id: 26 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610352-2025', title: 'Our Lady of the Valley', id: 27 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610668-2025', title: 'Queen of Peace Catholic Parish', id: 28 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610667-2025', title: 'Sacred Heart Catholic Church-Roggens', id: 29 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58644066-2025', title: 'Sacred Heart of Jesus', id: 30 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610755-2025', title: 'Saint Francis Cabrini', id: 31 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610801-2025', title: 'Shrine of St Annes', id: 32 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58677834-2025', title: 'Spirit of Christ', id: 33 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610896-2025', title: 'St Joan of Arc', id: 34 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610932-2025', title: 'St Mary Greeley', id: 35 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615235-2025', title: 'St Marys Rifle CO', id: 36 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610718-2025', title: 'St. Augustine', id: 37 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615878-2025', title: 'St. Elizabeth Ann Seton Parish', id: 38 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615800-2025', title: 'St. Francis of Assisi - Longmont ', id: 39 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610896-2025', title: 'St. Joan of Arc', id: 40 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58610896-2025', title: 'St. Joan of Arc', id: 41 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615803-2025', title: 'St. Joseph - Fort Collins', id: 42 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615192-2025', title: 'St. Louis ', id: 43 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615235-2025', title: 'St. Mary - Rifle', id: 44 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615738-2025', title: 'St. Peter Greeley', id: 45 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58611008-2025', title: 'St Scholastica, Erie, Colorado', id: 46 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615389-2025', title: 'St. Thomas More', id: 47 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58615425-2025', title: 'St.Joseph / Golden', id: 48 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-58618549-2025', title: 'Holy Name Catholic Church ', id: 49 },
    { ref: 'https://www.signupgenius.com/go/10C0B44AAAD2CA4F5C61-57242971-petition', title: 'Our Lady of Lourdes', id: 50 }
];

const SignUp = () => {
    const [query, setQuery] = useState('');

    const filteredItems = items.filter(
        (item) =>
            item.title.toLowerCase().includes(query.toLowerCase())
    );

    return (
        <div className="page">
            <header className="header">
                <img
                    src={logo}
                    alt="Header Icon"
                    className="header-image"
                />
                <h1 className="header-title">PKC - Petition Sign Up Links</h1>
            </header>

            <div className="search-box">
                <input
                    type="text"
                    placeholder="Search by Parish..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
            </div>

            <div className="grid">
                {filteredItems.map((item) => (
                    <div key={item.id} className="grid-item">
                        <h2>{item.title}</h2>
                        <a href={item.ref} target="_blank" rel="noopener noreferrer">{item.ref}</a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SignUp;
